import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const i = "privacy/messaging";
class r extends e {
  /**
   * Retrieves a specific messaging privacy policy by its ID.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/privacy/messaging/{policyId}`
   *
   * @param {string} policyId - The unique identifier of the messaging privacy policy to retrieve.
   * @returns {Promise<MessagingPrivacyPolicyData>} A promise resolving to the data of the requested messaging privacy policy.
   */
  getMessagingPrivacyPolicy = async (s) => {
    const { data: a } = await this.get(
      `${i}/${s}`
    );
    return a;
  };
}
export {
  i as MESSAGING_PRIVACY_POLICY_RESOURCE_URI,
  r as MessagingPrivacyPolicy
};
